import { createSlice } from "@reduxjs/toolkit";
import {
  AddReasonAction,
  DeleteReasonAction,
  GetAllReasonsAction,
  UpdateReasonAction,
  GetAllReasonsForSelectAction,
} from "store/middlewares/dataManagement/activityReason";

export const reasonSlice = createSlice({
  name: "reason",
  initialState: {
    activityReasonLoading: false,
    activityReason: null,
    allReasons: [],
    allReasonsLoading: false,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllReasonsAction.pending, (state) => {
        /* state.activityReasonLoading = true; */
        state.activityReason = null;
        state.activityReasonLoading =
          state.activityReasonLoading?.data?.length > 0
            ? state.activityReasonLoading
            : null;
      })
      .addCase(GetAllReasonsAction.fulfilled, (state, action) => {
        state.activityReasonLoading = false;
        state.activityReason = action.payload.response;
      })
      .addCase(GetAllReasonsAction.rejected, (state) => {
        state.activityReasonLoading = false;
        state.activityReason = null;
      })

      .addCase(AddReasonAction.pending, (state) => {
        state.activityReasonLoading =
          state.activityReasonLoading?.data?.length > 0
            ? state.activityReasonLoading
            : null;
      })
      .addCase(AddReasonAction.fulfilled, (state, action) => {
        state.activityReasonLoading = false;
        state.activityReason = action.payload.response;
      })
      .addCase(AddReasonAction.rejected, (state) => {
        state.activityReasonLoading = false;
      })

      .addCase(UpdateReasonAction.pending, (state) => {
        state.activityReasonLoading =
          state.activityReasonLoading?.data?.length > 0
            ? state.activityReasonLoading
            : null;
      })
      .addCase(UpdateReasonAction.fulfilled, (state, action) => {
        state.activityReasonLoading = false;
        state.activityReason = action.payload.response;
      })
      .addCase(UpdateReasonAction.rejected, (state) => {
        state.activityReasonLoading = false;
      })

      .addCase(DeleteReasonAction.pending, (state) => {
        state.activityReasonLoading = true;
        state.activityReasonLoading =
          state.activityReasonLoading?.data?.length > 0
            ? state.activityReasonLoading
            : null;
      })
      .addCase(DeleteReasonAction.fulfilled, (state, action) => {
        state.activityReasonLoading = false;
        state.activityReason = action.payload.response;
      })
      .addCase(DeleteReasonAction.rejected, (state) => {
        state.activityReasonLoading = false;
      })
      .addCase(GetAllReasonsForSelectAction.pending, (state) => {
        /* state.allReasonsLoading = true; */
        state.allReasonsLoading =
          state.allReasonsLoading?.data?.length > 0
            ? state.allReasonsLoading
            : null;
      })
      .addCase(GetAllReasonsForSelectAction.fulfilled, (state, action) => {
        state.allReasonsLoading = false;
        state.allReasons = action.payload.response ?? [];
      })
      .addCase(GetAllReasonsForSelectAction.rejected, (state) => {
        state.allReasonsLoading = false;
        state.allReasons = [];
      });
  },
});

export default reasonSlice.reducer;
